import React from "react";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import Spinner from "../../components/Spinner";
import OtpInput from "../../components/OtpInput";
import axios from "axios";
import "./../../css/Wireframe.css";

// Helper constants (flattened, no imports)
const API = localStorage.getItem("assethost");

export default class ForgotPasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      ipAddress: "",
      country: "",
      isp: "",
      loading: false,
      msg: "",
      toastColor: "",
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    // Get username from sessionStorage
    const username = sessionStorage.getItem("username") || "";
    this.setState({ username });

    // Get geo/ip info
    axios
      .get(
        "https://api.ipdata.co?api-key=212ad9acd89c4d7e42b8b70db2317c75e051aa7f16c81fed265ef9bd"
      )
      .then((res) => {
        this.setState({
          ipAddress: res?.data?.ip || "",
          country: res?.data?.country_name || "",
          isp: (res?.data?.asn && res.data.asn.name) || "",
        });
      })
      .catch(() => {});
  }

  handleConfirm(code) {
    if (!this.state.username) {
      this.setState({
        msg: "OTP is for unknown username",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const payload = {
      username: this.state.username,
      otpcode: Number(code),
      ipAddress: this.state.ipAddress,
      country: this.state.country,
      isp: this.state.isp,
    };

    axios
      .post(API + "/security/verifyotpcode", payload)
      .then((response) => {
        if (response.data.success) {
          sessionStorage.setItem("code", code);
          window.location.href = "/auth/forgot/new";
        } else {
          this.setState({
            msg: response?.data?.message || "Invalid code. Please try again.",
            toastColor: "danger",
          });
        }
      })
      .catch((err) => {
        this.setState({
          msg: err?.message || "Verification failed. Please try again.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleCancel(e) {
    if (e) e.preventDefault();
    window.history.back();
  }

  render() {
    const s = this.state;

    if (s.loading) {
      return <Spinner className="" />;
    }

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    return (
      <div className="min-h-screen h-dvh border flex flex-col pb-2">
        <Banner title="Forgot Password – Reset Code" />
        {divMsg}
        <div className="flex flex-col items-center mt-8 grow">
          <p className="mb-6 text-center">
            Enter the reset code to reset your password
          </p>
          <div className="wrapper space-y-3">
            <OtpInput
              key={`reset-pass-otp`}
              onReset={() => {}}
              onComplete={this.handleConfirm}
              autofocus={true}
              length={5}
            />
            <button className="btn btn-success" onClick={this.handleCancel}>
              Cancel
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
